import React from "react";
import { Link } from "react-router-dom";
import { Trophy } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/10 bg-[#0A0A0A] mt-16"
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-volt flex items-center justify-center">
              <Trophy className="w-5 h-5 text-black" strokeWidth={2.5} />
            </div>
            <span className="font-display text-2xl tracking-tighter">
              GOAL<span className="text-volt">GRID</span>
            </span>
          </div>
          <p className="mt-4 text-sm text-white/50 max-w-md">{t("footer.tagline")}</p>
        </div>

        <div>
          <h4 className="font-display text-lg tracking-wider text-white/90 mb-3">{t("footer.leagues")}</h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li>FIFA World Cup 2026</li>
            <li>Champions League</li>
            <li>Premier League</li>
            <li>La Liga</li>
            <li>Eredivisie</li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg tracking-wider text-white/90 mb-3">{t("footer.data")}</h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li>{t("footer.data_1")}</li>
            <li>{t("footer.data_2")}</li>
            <li>{t("footer.data_3")}</li>
            <li>
              <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-volt transition-colors">
                {t("footer.privacy")}
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-5 text-center text-xs text-white/30 uppercase tracking-[0.2em]">
        © {new Date().getFullYear()} GoalGrid — {t("footer.copyright")}
      </div>
    </footer>
  );
}
